// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"2059d55e","969":"1c8c19fd"}[chunkId] + ".chunk.js";
};